import { Clock, Calendar, TrendingUp, DollarSign } from 'lucide-react';

interface SummaryStatsProps {
  totalHours: number;
  totalMinutes: number;
  workDays: number;
  avgHoursPerDay: number;
  totalRecords: number;
  totalReward?: number;
}

export function SummaryStats({
  totalHours,
  totalMinutes,
  workDays,
  avgHoursPerDay,
  totalRecords,
  totalReward,
}: SummaryStatsProps) {
  const stats = [
    {
      label: '総稼働時間',
      value: `${totalHours}h`,
      subValue: `${totalMinutes}分`,
      icon: Clock,
      color: 'from-blue-500 to-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      label: '稼働日数',
      value: `${workDays}日`,
      subValue: `${totalRecords}件`,
      icon: Calendar,
      color: 'from-green-500 to-green-600',
      bgColor: 'bg-green-50',
    },
    {
      label: '平均稼働時間/日',
      value: `${avgHoursPerDay}h`,
      subValue: workDays > 0 ? `${Math.round((totalMinutes / workDays) * 10) / 10}分/日` : '-',
      icon: TrendingUp,
      color: 'from-purple-500 to-purple-600',
      bgColor: 'bg-purple-50',
    },
  ];

  // 🆕 報酬額カードを追加（報酬が設定されている場合のみ）
  if (totalReward !== undefined && totalReward > 0) {
    stats.push({
      label: '合計報酬',
      value: `¥${Math.round(totalReward).toLocaleString()}`,
      subValue: `${totalRecords}件の記録`,
      icon: DollarSign,
      color: 'from-orange-500 to-orange-600',
      bgColor: 'bg-orange-50',
    });
  }

  return (
    <div className={`grid grid-cols-1 ${stats.length === 4 ? 'md:grid-cols-4' : 'md:grid-cols-3'} gap-6 mb-8`}>
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <div
            key={stat.label}
            className={`${stat.bgColor} rounded-xl p-6 border border-gray-200 hover:shadow-lg transition-all duration-200`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 mb-2">{stat.label}</p>
                <p className="text-4xl font-bold text-gray-900">{stat.value}</p>
                {stat.subValue && (
                  <p className="text-sm text-gray-500 mt-1">{stat.subValue}</p>
                )}
              </div>
              <div
                className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${stat.color} flex items-center justify-center shadow-lg`}
              >
                <Icon className="w-8 h-8 text-white" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
